module.exports = __webpack_public_path__ + "static/media/deck-carousel-2.017441be.webp";